import { Grid, useMediaQuery, useTheme } from "@mui/material";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import ConciergePlanCard from "./Plan/PlanCard/Concierge";
import FreePlanCard from "./Plan/PlanCard/Free";
import ProPlanCard from "./Plan/PlanCard/Pro";
import VirtualAssistantPlanCard from "./Plan/PlanCard/VirtualAssistant";
import { getAllPlans } from "./Plan/helpers";

export default function Subscription() {
  const theme = useTheme();
  const { discoverTab } = useContext(DiscoverViewContext);
  const isMediumScreen = useMediaQuery("(max-width:1300px)");
  const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobileScreen =
    useMediaQuery(theme.breakpoints.down("md")) ||
    (isLargeScreen && discoverTab !== null);
  const { plans, tab, upgradeDialogSource } = useContext(SubscriptionContext);

  const plansToDisplay = getAllPlans(tab, upgradeDialogSource);

  const getGrid = () => {
    const totalPlans = plansToDisplay?.length;
    const columnByPlan = 12 / (totalPlans || 1);
    if (isMobileScreen) return 12;
    if (discoverTab !== null || isMediumScreen) {
      return Math.max(6, columnByPlan);
    }
    if (isLargeScreen) return Math.max(4, columnByPlan);
    return columnByPlan;
  };

  const renderPlan = (plan: Plans) => {
    if (plan === Plans.FREE) {
      return (
        <Grid key={plan} item xs={12} md={getGrid()}>
          <FreePlanCard plan={plan} />
        </Grid>
      );
    } else if (plan === Plans.PRO || plan === Plans.PRO_YEARLY) {
      return (
        <Grid key={plan} item xs={12} md={getGrid()}>
          <ProPlanCard plan={plan} />
        </Grid>
      );
    } else if (plan === Plans.VA || plan === Plans.VA_YEARLY) {
      return (
        <Grid key={plan} item xs={12} md={getGrid()}>
          <VirtualAssistantPlanCard plan={plan} />
        </Grid>
      );
    } else if (plan === Plans.CONCIERGE || plan === Plans.CONCIERGE_YEARLY) {
      return (
        <Grid key={plan} item xs={12} md={getGrid()}>
          <ConciergePlanCard plan={plan} />
        </Grid>
      );
    } else {
      return <></>;
    }
  };

  return plans ? (
    <>
      <Grid container spacing={1} sx={{ my: 3 }}>
        {plansToDisplay?.map((plan) => renderPlan(plan as Plans))}
      </Grid>
    </>
  ) : (
    <></>
  );
}
